(function () {
	var form = document.querySelector('.support-form');
	if (!form) {
		return;
	}

	var nameEl = form.querySelector('[data-support-summary-name]');
	var priceEl = form.querySelector('[data-support-summary-price]');
	var cards = form.querySelectorAll('.support-card');

	function periodKey() {
		var selected = form.querySelector('input[name="period"]:checked');
		return selected ? selected.value : 'monthly';
	}

	function priceFor(input, period) {
		if (!input) {
			return '';
		}
		var attr = 'data-support-' + period;
		return input.getAttribute(attr) || input.getAttribute('data-support-monthly') || '';
	}

	function syncCards() {
		var period = periodKey();
		Array.prototype.forEach.call(cards, function (card) {
			var input = card.querySelector('.support-card__input');
			var priceNode = card.querySelector('[data-support-card-price]');
			if (priceNode) {
				priceNode.textContent = priceFor(input, period);
			}
			if (input && input.checked) {
				card.classList.add('is-selected');
			} else {
				card.classList.remove('is-selected');
			}
		});
	}

	function syncSummary() {
		var selected = form.querySelector('input[name="tier"]:checked');
		var period = periodKey();
		if (nameEl) {
			nameEl.textContent = selected ? selected.getAttribute('data-support-name') || '' : '';
		}
		if (priceEl) {
			priceEl.textContent = priceFor(selected, period);
		}
	}

	function sync() {
		syncCards();
		syncSummary();
	}

	form.addEventListener('change', function (event) {
		var target = event.target;
		if (!target || !target.name) {
			return;
		}
		if (target.name === 'tier' || target.name === 'period') {
			sync();
		}
	});

	sync();
})();
